import { Box, styled, InputBase, IconButton } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import Button from "components/ui/Button";
import EditCatagoryModal from "components/ui/EditCatagoryModal/EditCatagoryModal";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import { useGlobalContext } from "context/GlobalContext";
import { useSettingContext } from "context/SettingContext";
import SortContext from "context/SortContext";
import { useEditCatagory } from "hooks/useEditCatagory";
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { handleSuccessNavigate, handleSuccessSettingRestricatNavigate, sendDataForEditCatagory } from "utils/editCatagoryHelper";
import { ReactComponent as SearchIconPlaceHolder } from "assets/icons/searchicon.svg";
import { useDispatch, useSelector } from "react-redux";
import { clearEditCategory } from "store/cartSlice";
import { updateMeltingRequest } from "features/Setting/Melting_Requests/API/meltingrequestapi";
const CancelButton = styled(Button)(({ }) => ({
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "22px",
  height: "42px",
  borderRadius: "5px",
  color: "#E77B7B",
  border: "1px solid #E77B7B",
  textTransform: "none",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "#E77B7B",
    color: "black",
  },
}));

const StyledButton = styled(Button)(({ bgcolor, variant, disabled }) => ({
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "22px",
  height: "42px",
  width: `${variant === "Next" ? "100px" : "auto"}`,
  borderRadius: "5px",
  color: `${variant === "Next" ? "#50C878" : "#ffffff"}`,
  border: `1px solid ${variant === "Next" ? "#50C878" : "#ffffff"}`,
  textTransform: "none",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: `${variant === "Next" ? "#50C878" : "transparent"}`,
    color: `${variant === "Next" ? "black" : "#ffffff"}`,
  },
  "&.Mui-disabled": {
    backgroundColor: "#000000",
    color: "#8B8B8B",
    border: "1px solid #8B8B8B",
  },
}));

// New styled button for Save Changes (for melting requests)
const SaveChangesButton = styled(Button)(({ disabled }) => ({
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "22px",
  height: "42px",
  borderRadius: "5px",
  color: "#50C878",
  border: "1px solid #50C878",
  textTransform: "none",
  backgroundColor: "transparent",
  "&:hover": {
    backgroundColor: "#50C878",
    color: "black",
  },
  "&.Mui-disabled": {
    backgroundColor: "#000000",
    color: "#8B8B8B",
    border: "1px solid #8B8B8B",
  },
}));

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#FFFFFF",
  "&:hover": {
    backgroundColor: "#f0f0f0",
  },
  marginLeft: 0,
  width: "100%",
  boxShadow: "inset 0px 4px 20px 0px #00000040",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "black",
  height: "40px",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 1),
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "40ch",
    },
  },
}));

const isCatagoryEdit = (isEditCatagoryData) => {
  return isEditCatagoryData && isEditCatagoryData.length > 0 ? false : true;
};

// Melting Selections Manager (Global State Management without localStorage)
// class MeltingSelectionsManager {
//   constructor() {
//     this.selections = [];
//     this.callbacks = new Set();
//   }

//   getSelections() {
//     return [...this.selections];
//   }

//   updateSelections(selections) {
//     this.selections = [...selections];

//     // Notify all callbacks
//     this.callbacks.forEach(callback => callback(this.selections));

//     // Dispatch event for other components
//     const event = new CustomEvent('meltingSelectionUpdated', {
//       detail: { selections: this.selections }
//     });
//     window.dispatchEvent(event);
//   }

//   subscribe(callback) {
//     this.callbacks.add(callback);
//     return () => this.callbacks.delete(callback);
//   }

//   clearSelections() {
//     this.selections = [];
//     this.callbacks.forEach(callback => callback(this.selections));

//     const event = new CustomEvent('meltingSelectionUpdated', {
//       detail: { selections: this.selections }
//     });
//     window.dispatchEvent(event);
//   }
// }

// // Create singleton instance
// const meltingManager = new MeltingSelectionsManager();

// // Export functions for other components
// export const updateMeltingSelections = (selections) => {
//   meltingManager.updateSelections(selections);
// };

// export const getMeltingSelections = () => {
//   return meltingManager.getSelections();
// };

// export const clearMeltingSelections = () => {
//   meltingManager.clearSelections();
// };

const RestricateCategoryHeader = () => {
  const [open, setOpen] = useState(false);
  const [tempSearch, setTempSearch] = useState("");
  const [restricModalOpen, setRestricModalOpen] = useState(false);
  const [modalType, setModalType] = useState(''); // 'save' or 'cancel'

  // Local state for melting request selections
  const [meltingSelections, setMeltingSelections] = useState([]);

  const { meltingRequestId } = useParams();

  const location = useLocation();
  const navigate = useNavigate();
  let [state, setState] = useState({});
  const [isEditDisabled, setIsEditDisabled] = useState(isCatagoryEdit(JSON.parse(sessionStorage.getItem(state?.updateCatagory)) || []));

  const quaryClient = useQueryClient();
  // const { isEditCatagoryData, setIsEditCatagoryData } = useGlobalContext();
  const { setRestrictBtn, setSyncButton, setSearch, search } = useSettingContext();

  // Check if we're on the melting requests page
  const isMeltingRequestPage = location.pathname.includes("/melting-requests");

  const dispatch = useDispatch();

  const isEditCatagoryData = useSelector(
    (state) => state.editCategory.data
  );

  const { mutate: updateCatagoryFun } = useEditCatagory({
    onCompleted: () =>
      handleSuccessSettingRestricatNavigate(
        location,
        () => {
          setRestricModalOpen(false);
          // setRestrictBtn(true);
          setSyncButton(true);
        },
        navigate
      ),
  });

  // Subscribe to melting selections updates
  // useEffect(() => {
  //   if (isMeltingRequestPage) {
  //     // Initialize from manager
  //     setMeltingSelections(meltingManager.getSelections());

  //     // Subscribe to updates
  //     const unsubscribe = meltingManager.subscribe((selections) => {
  //       setMeltingSelections(selections);
  //     });

  //     return unsubscribe;
  //   }
  // }, [isMeltingRequestPage]);

  // Handle Cancel for Restrict Design

  const handleCancel = () => {
    let newstate = {
      name: state?.name,
      innerChnages: false,
      updateCatagory: "",
    };
    // sessionStorage.removeItem("RestrictDesign");
    dispatch(clearEditCategory("RestrictDesign"));
    // setRestrictBtn(true);
    setSyncButton(true);
    // setIsEditCatagoryData([]);
    // quaryClient.invalidateQueries("designs");
    // quaryClient.removeQueries("designs");
    setSearch(null);
    navigate(state.backPath, { state: newstate });
  };


  const handleMeltingCancel = () => {
    let newstate = {
      name: state?.name,
      innerChnages: false,
      updateCatagory: "",
    };
    // dispatch(clearEditCategory("removeMeltingDesign"));
    setModalType('cancel');
    setOpen(true);
    setSyncButton(true);  
    
  };


  const handleSave = () => {
    if ("RestrictDesign".trim() === "RestrictDesign") {
      setRestricModalOpen(true);
    }
  };

  // Handle Save Changes for Melting Requests
  const handleSaveChanges = () => {
    setModalType('save');
    setOpen(true);
  };

  // // Handle Cancel for Melting Requests
  // const handleMeltingCancel = () => {
  //   // Check if there are any selected items
  //   if (meltingSelections.length > 0) {
  //     // If items are selected, show confirmation modal
  //     setModalType('cancel');
  //     setOpen(true);
  //   } else {
  //     // If no items are selected, navigate back directly
  //     navigateBackMeltingRequest();
  //   }
  // };

  // Navigate back for Melting Request

  const navigateBackMeltingRequest = () => {
    setSearch(null);
    navigate(-1);
  };

  // Actual function to save melting request changes
  // const saveMeltingRequestChanges = () => {
  //   // Here you would make your API call
  //   // Example: saveMeltingRequestAPI(meltingSelections);

  //   // Clear selections after successful save
  //   meltingManager.clearSelections();

  //   // Navigate back
  //   navigateBackMeltingRequest();
  // };

  const handleUnrestrictSave = () => {
    const updateStyleNumber = sendDataForEditCatagory("RestrictDesign");
    const updateStyles = {
      ...updateStyleNumber,
      updateValue: false,
    };
    updateCatagoryFun(updateStyles);
  };

  const modalBtnInfo = useMemo(
    () => [
      {
        btnName: "Discard",
        bgColor: "#E77B7B",
        click: handleCancel,
      },
      {
        btnName: "Keep",
        bgColor: "#50C878",
        click: () => setOpen(false),
      },
    ],
    [handleCancel]
  );

  // Modal button info for melting request
  const meltingModalBtnInfo = useMemo(() => {
    if (modalType === 'save') {
      return [
        {
          btnName: "Yes, Remove",
          bgColor: "#E77B7B",
          click: async () => {
            const payload = {
              melting_req_id: meltingRequestId,
              removeMeltingStock: isEditCatagoryData.map((item) => item.jewelCode),
            };
            try {
              const res = await updateMeltingRequest(payload);
              
              quaryClient.invalidateQueries({
                queryKey: ["melting-request-detail"],
              });
              quaryClient.invalidateQueries({ queryKey: ["melting-requests"] });
              setOpen(false);
              dispatch(clearEditCategory("removeMeltingDesign"));
              navigateBackMeltingRequest();
            } catch (error) {
              console.error("Failed to update:", error);
            }
          },
        },
        {
          btnName: "Keep",
          bgColor: "#50C878",
          click: () => setOpen(false),
        },
      ];
    } else {
      // For cancel modal
      return [
        {
          btnName: "Discard",
          bgColor: "#E77B7B",
          click: () => {
             dispatch(clearEditCategory("removeMeltingDesign"));
            // Clear selections when discarding
            // meltingManager.clearSelections();
            navigateBackMeltingRequest();
            setOpen(false);
          },
        },
        {
          btnName: "Keep",
          bgColor: "#50C878",
          click: () => setOpen(false),
        },
      ];
    }
  }, [modalType]);

  const restricModalBtnInfo = useMemo(
    () => [
      {
        btnName: "Unrestrict",
        bgColor: "#E77B7B",
        click: handleUnrestrictSave,
      },
      {
        btnName: "Keep",
        bgColor: "#50C878",
        click: () => setRestricModalOpen(false),
      },
    ],
    [handleUnrestrictSave]
  );

  const handleSearch = () => {
    setSearch(tempSearch);
  };

  useEffect(() => {
    return () => {
      setSearch("");
    };
  }, []);

  useEffect(() => {
    setState(location.state);
  }, [location]);

  const checkCategoryEditState = useCallback(() => {
    const data = JSON.parse(sessionStorage.getItem(state?.updateCatagory)) || [];
    // setIsEditCatagoryData(data);
    setIsEditDisabled(isCatagoryEdit(data));
  }, [state?.updateCatagory, isEditCatagoryData]);

  useEffect(() => {
    checkCategoryEditState();

    const handleSubcategoryUpdate = () => {
      checkCategoryEditState();
    };

    window.addEventListener("UpdateSubCategory", handleSubcategoryUpdate);

    return () => {
      window.removeEventListener("UpdateSubCategory", handleSubcategoryUpdate);
    };
  }, [checkCategoryEditState]);

  useEffect(() => {
    if (tempSearch === "") {
      setSearch("");
    }
  }, [tempSearch]);

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", gap: 4, mr: "10px" }}>
        <Search
          sx={{
            display: "flex",
            alignItems: "center",
            paddingLeft: "10px",
            paddingRight: "4px",
          }}
        >
          {/* Search Icon inside Input */}
          <SearchIconPlaceHolder sx={{ color: "gray", marginRight: "8px" }} />

          <StyledInputBase
            placeholder={isMeltingRequestPage
              ? "Search by Jewel Code or Design Number"
              : "Search By Category or Design Number"}
            onChange={(e) => setTempSearch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
            value={tempSearch}
            inputProps={{ "aria-label": "search" }}
            sx={{ height: "40px", borderRadius: "5px" }}
          />

          <IconButton
            disableRipple
            disableFocusRipple
            sx={{
              color: "black",
              height: "34px",
              width: "69px",
              borderRadius: "5px",
              padding: "10px",
              background: "#000",
              fontFamily: "poppins",
              color: "#fff",
              fontWeight: "500",
              fontSize: "12px",
            }}
            onClick={search === "" ? handleSearch : () => setSearch("")}
          >
            {search === "" ? "Search" : "Clear"}
          </IconButton>
        </Search>

        {/* Conditionally render buttons based on page */}
        {!isMeltingRequestPage ? (
          // Restrict Design Page - Original buttons
          <>
            <StyledButton onClick={handleSave} disabled={isEditDisabled} variant={"Next"}>
              Next
            </StyledButton>

            <CancelButton
              onClick={
                isCatagoryEdit(isEditCatagoryData)
                  ? handleCancel
                  : () => {
                    setOpen(true);
                    setSearch(null);
                  }
              }
            >
              Cancel
            </CancelButton>
          </>
        ) : (
          // Melting Request Page - New buttons
          <>
            <SaveChangesButton
              onClick={handleSaveChanges}
              disabled={isEditCatagoryData.length === 0}
            >
              Save Changes
            </SaveChangesButton>

            <CancelButton
              onClick={handleMeltingCancel}
            >
              Cancel
            </CancelButton>
          </>
        )}
      </Box>

      {/* Modals */}
      {isMeltingRequestPage ? (
        // Melting Request Modals
        <>
          {/* Save Changes Modal */}
          <RemoveModal
            open={open && modalType === 'save'}
            setOpen={setOpen}
            btnInfo={meltingModalBtnInfo}
            heading={`Are you sure you want to remove ${isEditCatagoryData.length} Design${isEditCatagoryData.length !== 1 ? "s" : ""}?`}
          />

          {/* Cancel Changes Modal */}
          <RemoveModal
            open={open && modalType === 'cancel'}
            setOpen={setOpen}
            btnInfo={meltingModalBtnInfo}
            heading="Do you want to discard all changes?"
          />
        </>
      ) : (
        // Restrict Design Modals
        <>
          {/* Cancel Changes Modal */}
          <RemoveModal
            open={open}
            setOpen={setOpen}
            btnInfo={modalBtnInfo}
            heading="Do you want to cancel the changes?"
          />

          {/* Unrestrict Modal */}
          <RemoveModal
            open={restricModalOpen}
            setOpen={setRestricModalOpen}
            btnInfo={restricModalBtnInfo}
            heading={`Do You Want To Unrestrict ${isEditCatagoryData.length || 0} Design${isEditCatagoryData.length > 1 ? "s" : ""} ?`}
          />
        </>
      )}
    </>
  );
};

export default RestricateCategoryHeader;